import { url } from '@js/utilities/url.js'
import ApiRequest from '@js/utilities/apiRequest.js'

export async function updateOffers(store, appData) {
    const responseData = await ApiRequest.post(store, url(`/monevo/re-search`), {
        loan_amount: appData.loanAmount || appData.loanValues.loan_amount,
        loan_term: process.env.TERRITORY === 'usa' ? null : appData.loanTerm || appData.loanValues.loan_term,
        reference: appData.loanValues.reference,
        loan_purpose: appData.loanPurpose,
        first_name: appData.loanValues.first_name,
        is_csl: appData.loanValues.is_csl,
        campaign_code: appData.loanValues.campaign_code,
        resubmitExpiredCreditCard: appData.resubmitExpiredCreditCard || false,
    })

    if (responseData) {
        appData.emitter.emit('reSubmitted', {
            loan_amount: appData.loanAmount || appData.loanValues.loan_amount,
            loan_term: process.env.TERRITORY === 'usa' ? null : appData.loanTerm || appData.loanValues.loan_term,
            loan_purpose: appData.loanValues.loan_purpose,
            results_url: responseData.results_url,
            new_url: responseData.new_url,
            declined_url: responseData.declined_url,
            redirect_url: responseData.redirect_url,
        })
    }
}
